import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import {
  AuthGuard,
  roleGuard,
  storageLocationsResolver,
} from '@knust/core';
import { UserEnum } from '@knust/api-interfaces';

// Entspricht der Menü-Logik in core.component.html
const adminOnly = roleGuard(UserEnum.ADMIN);
const adminOrPurchasing = roleGuard(UserEnum.ADMIN, UserEnum.PURCHASING);

const routes: Route[] = [
  {
    path: 'login',
    loadChildren: () => import('@knust/core').then((m) => m.LoginModule),
  },
  {
    path: 'entnahmen',
    loadChildren: () => import('@knust/core').then((m) => m.TrunksModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'benutzer',
    loadChildren: () => import('@knust/core').then((m) => m.UsersModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'stammdaten',
    loadChildren: () => import('@knust/core').then((m) => m.BaseDataModule),
    canActivate: [AuthGuard, adminOnly],
  },
  {
    path: 'lieferanten',
    loadChildren: () => import('@knust/core').then((m) => m.VendorsModule),
    canActivate: [AuthGuard, adminOrPurchasing],
  },
  {
    path: 'lagerorte',
    loadComponent: () =>
      import('@knust/core').then((m) => m.StorageLocationsComponent),
    canActivate: [AuthGuard],
    resolve: { storageLocations: storageLocationsResolver },
  },
  {
    path: 'lagerorte/:storageLocationId',
    loadComponent: () =>
      import('@knust/core').then((m) => m.StorageLocationArticlesComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'artikel',
    loadChildren: () => import('@knust/core').then((m) => m.ArticlesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'wareneingangsbuchung',
    loadChildren: () => import('@knust/core').then((m) => m.DeliveryModule),
    canActivate: [AuthGuard, adminOrPurchasing],
  },
  {
    path: 'lagerbuchung',
    loadChildren: () => import('@knust/core').then((m) => m.BookingsModule),
    canActivate: [AuthGuard, adminOrPurchasing],
  },
  {
    path: 'papierkorb',
    loadChildren: () => import('@knust/core').then((m) => m.TrashModule),
    canActivate: [AuthGuard, adminOnly],
  },
  {
    path: 'import',
    loadChildren: () => import('@knust/core').then((m) => m.ImportModule),
    canActivate: [AuthGuard, adminOnly],
  },
  {
    path: 'berichte',
    loadChildren: () => import('@knust/core').then((m) => m.ReportsModule),
    canActivate: [AuthGuard, adminOnly],
  },
  {
    path: '**',
    redirectTo: 'artikel',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { canceledNavigationResolution: 'computed' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
